import React from 'react';
var OptionWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { style: {
            paddingTop: '8px',
            width: '100%',
        } }, children));
};
export default OptionWrapper;
